import { languages } from '@/config/languages.config'

export const getLangByCode = langCode => {
  const language = languages.find(lang => lang.code === langCode)
  return language?.name || ''
}
